import { isValid } from 'date-fns';

export const validateRequired = (data: any) => {
  return !data ? 'required' : undefined;
};
export const validateEmail = (data: string) => {
  if (data && data.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/gi) === null) {
    return 'invalid-email';
  } else {
    return undefined;
  }
};
export const validateURL = (data: string) => {
  if (!data) return undefined;

  const value = data.trim();
  if (!value) return undefined;

  // Reject common local file/path shapes up-front (Windows/macOS/Linux).
  // Examples: C:\path, C:/path, \\server\share, /Users/name/file, file:///C:/path
  if (
    /^[a-zA-Z]:[\\/]/.test(value) ||
    value.startsWith('\\\\') ||
    value.startsWith('/') ||
    value.toLowerCase().startsWith('file:')
  ) {
    return 'invalid-url';
  }

  const withProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(value) ? value : `https://${value}`;

  try {
    const url = new URL(withProtocol);

    // Only internet links.
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return 'invalid-url';
    if (!url.hostname) return 'invalid-url';

    // Require a domain-like hostname (prevents many false-positives like "myfile.txt").
    // If you need to allow intranet hosts like "myhost" later, relax this check.
    if (!url.hostname.includes('.')) return 'invalid-url';

    return undefined;
  } catch {
    return 'invalid-url';
  }
};
export const validateNumber = (data: string) => {
  const value = Number(data);
  if (data && isNaN(value)) {
    return 'invalid-number';
  } else {
    return undefined;
  }
};
export const validateDate = (data: string | Date) => {
  // date-fns v4 isValid() treats any string as invalid: a date loaded from the API is an ISO string.
  if (data && !isValid(typeof data === 'string' ? new Date(data) : data)) {
    return 'invalid-date';
  } else {
    return undefined;
  }
};
export const validateMixin = (data: any) => {
  if (data) {
    if (typeof data === 'object') {
      if (data?.value && data?.value?.length) return undefined;
    } else {
      return undefined;
    }
  }
  return 'required';
}
export const validatePositiveNumber = (data: string) => {
  if (!data) return undefined;

  const value = Number(data);

  if (isNaN(value)) {
    return 'invalid-number';
  }

  if (value < 0) {
    return 'number-must-be-positive';
  }

  return undefined;
};

export const validateRule = (rule = '') => {
  if (typeof rule !== 'string') {
    return undefined;
  }

  return rule.split(',').reduce((result: any, key: string) => {
    switch (key) {
      case 'required':
        result['required'] = 'required';
        break;
      case 'requiredEditor':
        result['validate'] = (data: any) => {
          if (data) {
            if (typeof data === 'object') {
              if (data?.value && data.value.length && data.value.length) {
                const div = document.createElement('div');
                div.innerHTML = data.value;
                const text = div.textContent || div.innerText || '';
                div.remove();
                if (text.length) {
                  return undefined;
                } else {
                  return 'required';
                }
              } else {
                return 'required';
              }
            } else {
              return undefined;
            }
          }
          return 'required';
        };
        break;
      case 'requiredMixin':
        result['validate'] = validateMixin;
        break;
      case 'minLength':
        result['minLength'] = {
          value: 2,
          message: 'length-min-error',
        };
        break;
      case 'email':
        result['validate'] = validateEmail;
        break;
      case 'url':
        result['validate'] = validateURL;
        break;
      case 'number':
        result['validate'] = validateNumber;
        break;
      case 'date':
        result['validate'] = validateDate;
        break;
      case 'positiveNumber':
        result['validate'] = validatePositiveNumber;
        break;
    }
    return result;
  }, {});
};
